module.exports = __webpack_public_path__ + "02c78963f4993528a03b322e1fcf0f8f.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=410!./images/projekte/lokalrunde-1.jpg
// module id = 523
// module chunks = 0